import { Injectable, OnDestroy } from '@angular/core';
import { CheckoutSelectors, CustomCheckoutState, StateWithCustomCheckout } from '@checkout-v2/data-access';
import { Store } from '@ngrx/store';
import { StatePersistenceService, StorageSyncType } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { CheckoutContactFormService } from './checkout-contact-form.service';
import { CheckoutService } from './checkout.service';
import { DeliveryAddressService } from './delivery-address.service';
import { PickupService } from './pickup.service';

@Injectable({ providedIn: 'root' })
export class CheckoutPersistenceService implements OnDestroy {
  private subscription = new Subscription();

  constructor(
    private statePersistenceService: StatePersistenceService,
    private checkoutService: CheckoutService,
    private pickupService: PickupService,
    private deliveryAddressService: DeliveryAddressService,
    private store: Store<StateWithCustomCheckout>,
    private checkoutContactFormService: CheckoutContactFormService,
  ) {}

  sync(): void {
    this.subscription.add(
      this.statePersistenceService.syncWithStorage({
        key: 'customCheckout',
        state$: this.getCheckoutState(),
        storageType: StorageSyncType.SESSION_STORAGE,
        onRead: (state) => this.onRead(state),
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  onRead(state: CustomCheckoutState | undefined): void {
    if (!state) {
      return;
    }

    if (state.orderDetails && Object.keys(state.orderDetails).length > 0) {
      this.checkoutService.setOrderDetails(state.orderDetails);
    }

    if (state.activeModes.receiptType) {
      this.checkoutService.updateReceiptType(state.activeModes.receiptType);

      // при текущей реализации чекаута необходимо проверять receiptType, чтобы не получилось
      // одновременно и выбранный адрес и магазин
      if (state.activeModes.receiptType === 'pickup' && state.activeModes.pickup) {
        this.pickupService.setShop(state.activeModes.pickup);
      }

      if (state.activeModes.receiptType === 'delivery' && state.activeModes.addressId) {
        this.deliveryAddressService.selectActiveAddressId(state.activeModes.addressId);
      }

      if (state.activeModes.contacts) {
        this.checkoutContactFormService.setValue(state.activeModes.contacts);
      }
    }
  }

  private getCheckoutState(): Observable<CustomCheckoutState> {
    return this.store.select(CheckoutSelectors.getCustomCheckoutState);
  }
}
